import { useTranslation } from "react-i18next";
import LegalLayout from "./LegalLayout";

const FR = (
  <>
    <section>
      <p className="text-slate-600">
        La présente politique décrit comment Valentin BECHAMEIL («&nbsp;nous&nbsp;»),
        éditeur du site adonis-agency.eu, collecte et traite vos données
        personnelles, conformément au Règlement (UE) 2016/679 (RGPD) et à la
        loi n° 78-17 du 6 janvier 1978 modifiée.
      </p>
    </section>

    <section>
      <h2>1. Responsable du traitement</h2>
      <p>
        Valentin BECHAMEIL, 61 rue de Lyon, 75012 Paris. Contact :{" "}
        <a href="mailto:contact@adonis-agency.eu">contact@adonis-agency.eu</a>.
      </p>
      <p>
        Aucun délégué à la protection des données n'est désigné, sa désignation
        n'étant pas obligatoire au regard de notre activité.
      </p>
    </section>

    <section>
      <h2>2. Données collectées</h2>
      <p>
        Nous collectons un minimum de données, essentiellement dans le cadre du
        processus de candidature et de la relation avec nos clients :
      </p>
      <ul>
        <li>
          <strong>Candidature</strong> : nom, prénom, adresse e-mail, numéro de
          téléphone et identifiants de vos comptes de réseaux sociaux.
        </li>
        <li>
          <strong>Demande de contact</strong> : si vous nous écrivez, votre
          adresse e-mail et le contenu de votre message.
        </li>
        <li>
          <strong>Clients (formation ou accompagnement)</strong> : identifiants
          de connexion à l'espace de formation et données nécessaires à la
          facturation et à la comptabilité.
        </li>
      </ul>
      <p>
        Les paiements s'effectuent par virement bancaire (SEPA). Nous ne
        collectons ni ne conservons de données de carte bancaire.
      </p>
    </section>

    <section>
      <h2>3. Finalités et bases légales</h2>
      <ul>
        <li>
          Traiter votre candidature et échanger avec vous : exécution de
          mesures précontractuelles.
        </li>
        <li>
          Fournir la formation ou l'accompagnement et donner accès à l'espace
          de formation : exécution du contrat.
        </li>
        <li>
          Établir la facturation et respecter nos obligations comptables :
          obligation légale.
        </li>
        <li>
          Vous adresser les e-mails liés à votre candidature ou à votre compte,
          y compris les messages automatiques de notre plateforme : exécution
          du contrat ou intérêt légitime.
        </li>
        <li>
          Assurer la sécurité et le bon fonctionnement du site : intérêt
          légitime.
        </li>
      </ul>
    </section>

    <section>
      <h2>4. Destinataires</h2>
      <p>
        Vos données sont traitées pour notre seul usage interne. Nous ne les
        vendons pas, ne les louons pas et ne les partageons pas avec des tiers
        à des fins commerciales. Le seul prestataire technique ayant accès à
        l'infrastructure est notre hébergeur, Axeris Labs (Union européenne),
        tenu à une obligation de confidentialité. Vos données peuvent être
        communiquées aux autorités compétentes en cas d'obligation légale.
      </p>
    </section>

    <section>
      <h2>5. Hébergement et localisation</h2>
      <p>
        Vos données sont hébergées et traitées au sein de l'Union européenne.
        Aucun transfert n'est réalisé en dehors de l'Union européenne.
      </p>
    </section>

    <section>
      <h2>6. Durées de conservation</h2>
      <ul>
        <li>
          Candidatures non retenues : 6 mois après le dernier échange, puis
          suppression.
        </li>
        <li>
          Demandes de contact sans suite : le temps nécessaire au traitement,
          puis suppression.
        </li>
        <li>
          Clients : pendant la durée de la relation, puis archivage selon les
          obligations légales (pièces comptables : 10 ans).
        </li>
        <li>Cookies strictement nécessaires : le temps de la session.</li>
      </ul>
    </section>

    <section>
      <h2>7. Sécurité</h2>
      <p>
        Nous mettons en œuvre des mesures techniques et organisationnelles
        appropriées (accès restreints, hébergement sécurisé, connexion HTTPS)
        pour protéger vos données.
      </p>
    </section>

    <section>
      <h2>8. Cookies</h2>
      <p>
        Le site utilise uniquement des cookies strictement nécessaires à son
        fonctionnement et à sa sécurité. Conformément aux recommandations de la
        CNIL, ces cookies sont exemptés de consentement préalable : aucun
        bandeau n'est donc nécessaire. Nous n'utilisons aucun cookie de mesure
        d'audience ni aucun traceur publicitaire.
      </p>
    </section>

    <section>
      <h2>9. Vos droits</h2>
      <p>
        Vous disposez des droits d'accès, de rectification, d'effacement, de
        limitation, d'opposition et de portabilité, ainsi que du droit de
        définir des directives relatives au sort de vos données après votre
        décès. Pour les exercer, écrivez à{" "}
        <a href="mailto:contact@adonis-agency.eu">contact@adonis-agency.eu</a>{" "}
        (une preuve d'identité pourra être demandée). Nous répondons dans un
        délai d'un mois.
      </p>
    </section>

    <section>
      <h2>10. Réclamation</h2>
      <p>
        Vous pouvez introduire une réclamation auprès de la CNIL : 3 place de
        Fontenoy, TSA 80715, 75334 Paris Cedex 07,{" "}
        <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">
          www.cnil.fr
        </a>
        .
      </p>
    </section>

    <section>
      <h2>11. Public majeur</h2>
      <p>
        Nos services s'adressent exclusivement à des personnes majeures (18 ans
        et plus). Nous ne collectons pas sciemment de données concernant des
        mineurs.
      </p>
    </section>

    <section>
      <h2>12. Modifications</h2>
      <p>
        La présente politique peut être mise à jour. La date de dernière mise
        à jour figure en tête de document.
      </p>
    </section>
  </>
);

const EN = (
  <>
    <section>
      <p className="text-slate-600">
        This policy describes how Valentin BECHAMEIL (&ldquo;we&rdquo;),
        publisher of adonis-agency.eu, collects and processes your personal
        data, in accordance with Regulation (EU) 2016/679 (GDPR) and the French
        Data Protection Act of 6 January 1978 as amended.
      </p>
    </section>

    <section>
      <h2>1. Data controller</h2>
      <p>
        Valentin BECHAMEIL, 61 rue de Lyon, 75012 Paris. Contact:{" "}
        <a href="mailto:contact@adonis-agency.eu">contact@adonis-agency.eu</a>.
      </p>
      <p>
        No data protection officer is appointed, as such designation is not
        mandatory given our activity.
      </p>
    </section>

    <section>
      <h2>2. Data collected</h2>
      <p>
        We collect a minimum of data, mainly within the application process and
        in the relationship with our clients:
      </p>
      <ul>
        <li>
          <strong>Application</strong>: last name, first name, email address,
          phone number and identifiers of your social media accounts.
        </li>
        <li>
          <strong>Contact request</strong>: if you write to us, your email
          address and the content of your message.
        </li>
        <li>
          <strong>Clients (training or coaching)</strong>: login credentials
          for the training space and data required for invoicing and
          accounting.
        </li>
      </ul>
      <p>
        Payments are made by bank transfer (SEPA). We do not collect or store
        any credit card data.
      </p>
    </section>

    <section>
      <h2>3. Purposes and legal bases</h2>
      <ul>
        <li>
          Processing your application and exchanging with you: pre-contractual
          measures.
        </li>
        <li>
          Providing training or coaching and granting access to the training
          space: performance of the contract.
        </li>
        <li>
          Issuing invoices and meeting our accounting obligations: legal
          obligation.
        </li>
        <li>
          Sending you emails related to your application or your account,
          including automatic messages from our platform: performance of the
          contract or legitimate interest.
        </li>
        <li>
          Ensuring the security and proper functioning of the site: legitimate
          interest.
        </li>
      </ul>
    </section>

    <section>
      <h2>4. Recipients</h2>
      <p>
        Your data is processed for our internal use only. We do not sell, rent
        or share it with third parties for commercial purposes. The only
        technical provider with access to the infrastructure is our host,
        Axeris Labs (European Union), bound by a confidentiality obligation.
        Your data may be disclosed to the competent authorities in case of
        legal obligation.
      </p>
    </section>

    <section>
      <h2>5. Hosting and location</h2>
      <p>
        Your data is hosted and processed within the European Union. No
        transfer is made outside the European Union.
      </p>
    </section>

    <section>
      <h2>6. Retention periods</h2>
      <ul>
        <li>
          Unsuccessful applications: 6 months after the last exchange, then
          deleted.
        </li>
        <li>
          Contact requests without follow-up: time required for processing,
          then deleted.
        </li>
        <li>
          Clients: throughout the duration of the relationship, then archived
          per legal obligations (accounting documents: 10 years).
        </li>
        <li>Strictly necessary cookies: session-only.</li>
      </ul>
    </section>

    <section>
      <h2>7. Security</h2>
      <p>
        We implement appropriate technical and organizational measures
        (restricted access, secure hosting, HTTPS connection) to protect your
        data.
      </p>
    </section>

    <section>
      <h2>8. Cookies</h2>
      <p>
        The site only uses cookies strictly necessary for its operation and
        security. In accordance with CNIL recommendations, these cookies are
        exempt from prior consent: no banner is therefore required. We do not
        use any audience measurement cookies or advertising trackers.
      </p>
    </section>

    <section>
      <h2>9. Your rights</h2>
      <p>
        You have the rights of access, rectification, erasure, restriction,
        objection and portability, as well as the right to define directives
        regarding the fate of your data after death. To exercise them, write
        to{" "}
        <a href="mailto:contact@adonis-agency.eu">contact@adonis-agency.eu</a>{" "}
        (proof of identity may be requested). We reply within one month.
      </p>
    </section>

    <section>
      <h2>10. Complaint</h2>
      <p>
        You may lodge a complaint with the CNIL: 3 place de Fontenoy, TSA
        80715, 75334 Paris Cedex 07,{" "}
        <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">
          www.cnil.fr
        </a>
        .
      </p>
    </section>

    <section>
      <h2>11. Adult audience</h2>
      <p>
        Our services are exclusively intended for adults (18 years old and
        over). We do not knowingly collect data concerning minors.
      </p>
    </section>

    <section>
      <h2>12. Updates</h2>
      <p>
        This policy may be updated. The latest update date appears at the top
        of the document.
      </p>
    </section>
  </>
);

export default function PrivacyPolicy() {
  const { i18n } = useTranslation();
  const isFR = (i18n.language || "fr").startsWith("fr");
  return (
    <LegalLayout
      testId="privacy-page"
      kickerKey="legal.kicker_long"
      titleKey="footer.privacy"
      updatedAtKey="legal.privacy_updated_at"
    >
      {isFR ? FR : EN}
    </LegalLayout>
  );
}
